<template>
  <div class="basket-preorder-warning">
    <v-container>
      <transition name="fade">
        <p v-if="deliveryFromText" class="basket-preorder-warning__note h5 limited mt-8 mx-auto text-center">
          В корзине есть товары по предзаказу, доставка возможна с {{ deliveryFromText }}
          <br v-if="ticketsText">{{ ticketsText }}
        </p>
      </transition>
    </v-container>
  </div>
</template>

<script>
import {end} from '@/utils/string';

export default {
  name: 'basket-preorder-warning',
  computed: {
    // по билету на каждую единицу товара по предзаказу
    ticketsText() {
      const n = this.$store.getters.basketPreorderQuantity;
      if (!n) return null;
      return `+ ${n} ${end(n, 'билет', 'билета', 'билетов')} в подарок`;
    },
    deliveryFromText() {
      const date = this.$store.getters.basketPreorderDeliveryFrom;
      if (!date) return null;
      const [year, month, day] = date.split('-').map(Number);
      return new Date(year, month - 1, day).toLocaleDateString('ru-RU', {day: 'numeric', month: 'long'});
    },
  },
}
</script>

<style lang="scss">
.basket-preorder-warning {
  &__note {
    border: 2px solid $golden;
    padding: 20px;
  }
}
</style>
